import { createTheme, ThemeProvider } from '@mui/material';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import LandingPage from './pages/LandingPage';
import Header from './components/Header';
import LoginPage from './pages/LoginPage';
import SignupPage from './pages/SignupPage';
import DashboardPage from './pages/DashboardPage';
import ProtectedRoute from './components/ProtectedRoute';
import TaskMarketplacePage from './pages/TaskMarketplacePage';
import TaskDetailPage from './pages/TaskDetailPage';
import MyTasksPage from './pages/MyTasksPage';
import TaskExecutionPage from './pages/TaskExecutionPage';
import EarningsPage from './pages/EarningsPage';
import ProfilePage from './pages/ProfilePage';
import CommunityPage from './pages/CommunityPage';
import HelpCenterPage from './pages/HelpCenterPage';
import AdminRegister from './pages/admin/AdminRegister';
import UserManagement from './pages/admin/UserManagement';
import HelpRequests from './pages/admin/HelpRequests';
import TierUpgrade from './components/TierUpgrade';
import LeaderboardPage from './pages/LeaderboardPage';
import AchievementsPage from './pages/AchievementsPage';
import DashboardLayout from './components/DashboardLayout';
import ConsentRejectedPage from './pages/ConsentRejectedPage';

// NEW ADMIN PANEL IMPORTS
import AdminLogin from './pages/admin/AdminLogin';
import AdminDashboard from './pages/admin/AdminDashboard';
import ProtectedAdminRoute from './components/ProtectedAdminRoute'; 
import TaskModeration from './pages/admin/TaskModeration';

console.log(DashboardPage);
//  existing theme
const theme = createTheme({
  palette: {
    primary: { main: '#4CAF50' },  // Green
    secondary: { main: '#2E7D32' }, // Dark green
  },
});

function App() {
  return (
    <ThemeProvider theme={theme}>
      <Router>
        <Routes>
          <Route path="/" element={<LandingPage />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/signup" element={<SignupPage />} />
            <Route 
                path="/dashboard" 
                element={
                  <ProtectedRoute>
                    <DashboardPage />
                  </ProtectedRoute>
                } 
              />
                <Route path="/tasks" element={
                  <ProtectedRoute>
                    <TaskMarketplacePage />
                  </ProtectedRoute>
                } />
                <Route path="/tiers" element={
                  <ProtectedRoute>
                    <TierUpgrade />
                  </ProtectedRoute>
                } />

                <Route path="/leaderboard" element={
                  <ProtectedRoute>
                    <DashboardLayout>
                      <LeaderboardPage />
                    </DashboardLayout>
                  </ProtectedRoute>
                } />

                  <Route path="/achievements" element={
                    <ProtectedRoute>
                      <DashboardLayout>
                        <AchievementsPage />
                      </DashboardLayout>
                    </ProtectedRoute>
                  } />

                <Route path="/task/:taskId" element={<ProtectedRoute><TaskDetailPage /></ProtectedRoute>} />
                <Route path="/my-tasks" element={<ProtectedRoute><MyTasksPage /></ProtectedRoute>} />
                <Route path="/task/:taskId/execute" element={<ProtectedRoute><TaskExecutionPage /></ProtectedRoute>} />
                <Route path="/earnings" element={<ProtectedRoute><EarningsPage /></ProtectedRoute>} />
                <Route path="/profile" element={<ProtectedRoute><ProfilePage /></ProtectedRoute>} />
                <Route path="/community" element={<ProtectedRoute><CommunityPage /></ProtectedRoute>} />
                <Route path="/help" element={<ProtectedRoute><HelpCenterPage /></ProtectedRoute>} />
                 <Route path="/consent-rejected" element={<ConsentRejectedPage />} />
          
          {/* NEW: Admin Panel Routes */}
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route 
          path="/admin/dashboard" 
          element={
            <ProtectedAdminRoute>
              <AdminDashboard />
            </ProtectedAdminRoute>
          } 
        />
         <Route 
            path="/admin/register" 
            element={
              <ProtectedAdminRoute>
                <AdminRegister />
              </ProtectedAdminRoute>
            } 
          />
          <Route 
            path="/admin/users" 
            element={
              <ProtectedAdminRoute>
                <UserManagement />
              </ProtectedAdminRoute>
            } 
          />
          <Route 
              path="/admin/tasks" 
              element={
                <ProtectedAdminRoute>
                  <TaskModeration />
                </ProtectedAdminRoute>
              } 
            />
        <Route path="/admin/HelpRequests" element={<ProtectedAdminRoute><HelpRequests /></ProtectedAdminRoute>} />
                      {/* 404 Route */}
        <Route path="*" element={<h1>404 - Page Not Found</h1>} />

          </Routes>
      </Router>
    </ThemeProvider>
  );
}

export default App;